import {Icon} from 'antd'
import autobind from 'autobind-decorator'
import * as React from 'react'
import {withTranslation, WithTranslation} from 'react-i18next'
import {connect} from 'redux-scaffolding-ts'
import {ItemReference, QueryResult} from 'src/core/stores/dataStore'
import {ProjectTemplatesStore} from 'src/stores/templates-store'
import SelectionInput from '../core/ui/form/selectionInput'

export interface EditorProps {
    companyId: string;
    disabled?: boolean;
    onChange?: (value: string[]) => void;
    placeholder?: string;
    minWidth?: number;
}

interface ProjectTemplateEditorProps extends EditorProps, WithTranslation {
    value?: string[]
}

interface ProjectTemplateEditorState {
    value: string[],
}

@connect(["projectTemplates", ProjectTemplatesStore])
class ProjectTemplateEditor extends React.Component<ProjectTemplateEditorProps, ProjectTemplateEditorState> {

    private get ProjectTemplatesStore() {
        return (this.props as any).projectTemplates as ProjectTemplatesStore;
    }

    constructor(props: ProjectTemplateEditorProps) {
        super(props);
        this.state = {
            value: props.value ?? []
        }
        this.onChange(props.value)
        this.ProjectTemplatesStore.changeUrl(props.companyId);
    }


    static getDerivedStateFromProps(nextProps: ProjectTemplateEditorProps, prevState: ProjectTemplateEditorState) {
        if (nextProps.value !== prevState.value) {
            return { value: nextProps.value ?? [] };
        }
        else return null;
    }


    @autobind
    private async getProjectTemplates(searchQuery: string): Promise<QueryResult<ItemReference>> {
        var result = await this.ProjectTemplatesStore.getAllAsync({
            searchQuery: searchQuery,
            skip: 0,
            parameters: {
                "includeIds": [`${this.props.value}`],
            },
            take: 25,
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
        }) || { count: 0, items: [] };

        return {
            count: result.count,
            items: result.items.map(o => ({
                id: `${o.id}`,
                title: `${o.title}`
            } as ItemReference))
        } as QueryResult<ItemReference>
    }

    @autobind
    private onChange(item: any) {
        if (this.props.onChange) { this.props.onChange(item as string[]) }
    }

    public render() {
        return (<SelectionInput
            content={(o) =>
                <div>
                    <Icon type="layout" />
                    <span>&nbsp;{o ? o.title : ""}</span>
                </div>}
            searchable
            disabled={this.props.disabled}
            minWidth={this.props.minWidth}
            placeholder={this.props.placeholder}
            query={this.getProjectTemplates}
            value={this.state.value}
            multiple
            nullable
            onChange={this.onChange} />);
    }
}

export default withTranslation()(ProjectTemplateEditor);